import axiosClient from '../config/axiosConfig';

export const userlogin = (payload, token) => {
  return axiosClient('auth/user/login', payload, 'POST');
};
export const userSignup = (payload, token) => {
  return axiosClient('auth/user/signup', payload, 'POST');
};

export const getUsdtAddress = (payload, token) => {
  return axiosClient('preSale/get-usdt-address', payload, 'GET');
};

export const getInfiTokenPrice = (payload, token) => {
  return axiosClient('preSale/get-INFIPrice', payload, 'GET');
};

export const getPresaleStatistics = (payload, token) => {
  return axiosClient('preSale/PresaleStatistics', payload, 'GET');
};
export const getTotalPurchased = (walletAddress) => {
  return axiosClient('preSale/get-infi-to-send/' + walletAddress, {}, 'GET');
};

export const buyTransactionHistory = (wallet_address, token) => {
  return axiosClient(
    'user/buy-transaction-list/' + wallet_address,
    {},
    'GET',
    {}
  );
};

export const getRecentTransactions = async () => {
  return axiosClient('user/buy-recentTransaction-list', {}, 'GET');
};

export const getPhaseDetails = async () => {
  return axiosClient('preSale/PhaseInfo', {}, 'GET');
};

export const getPresaleInfiBalance = async () => {
  return axiosClient('preSale/PreSaleInfiBalance', {}, 'GET');
};

export const getFaqQuestions = async (id) => {
  return axiosClient('cms-faq/faq-question/' + id, {}, 'GET');
};
export const GetAllFAQsAction = async () => {
  return axiosClient('cms-faq/getFaq/', {}, 'GET');
};

export const getAllBlogsAction = async () => {
  return axiosClient('cms-blog/getAllBlogs', {}, 'GET');
};
export const getBlogByIdAction = async (id) => {
  return axiosClient('cms-blog/getBlogById/' + id, {}, 'GET');
};

export const getFaqAnswers = async (id) => {
  return axiosClient('cms-faq/faq-answer/' + id, {}, 'GET');
};

export const getContent = async () => {
  return axiosClient('cms-content/get-content/', {}, 'GET');
};

export const getRoadmapOne = async (id) => {
  return axiosClient('cms-roadmap/roadone/' + id, {}, 'GET');
};
export const roadmapsList = async (id) => {
  return axiosClient('cms-roadmap/roadmapsList', {}, 'GET');
};
export const getAllRoadMapAction = async (id) => {
  return axiosClient('roadmap/getAllRoadMap', {}, 'GET');
};

export const getRoadmapTwo = async (id) => {
  return axiosClient('cms-roadmap/roadtwo/' + id, {}, 'GET');
};

export const getRoadmapThree = async (id) => {
  return axiosClient('cms-roadmap/roadthree/' + id, {}, 'GET');
};

export const getRoadmapFour = async (id) => {
  return axiosClient('cms-roadmap/roadfour/' + id, {}, 'GET');
};

// export const getRoadmapFour = async (id) => {
//   const response = await fetch(
//     `http://localhost:9090/api/cms-roadmap/roadfour/${id}`,
//     {
//       method: 'GET',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//     }
//   );
//   return response.text();
// };

export const getMetadata = async () => {
  return axiosClient('metadata/get-metadata', {}, 'GET');
};
